<template lang="jade">
component(":is"='duplicate.type'
          ":fdata.sync"='duplicate'
          ":dispatch"="dispatch"
          ":paste"="paste")         
</template>

<script>
import _ from 'lodash'
import { forms, config } from 'src/vuex/getters'
import { addNotification,
         removeNotification } from 'src/vuex/actions'

export default {
  data () {
    return {
      uid: this.$parent.uid,
      duplicate: {},
      paste: false,
      formInput: {},
      dispatch: true,
      attempts: 0,
      validation: false
    }
  },

  props: {
    fdata: {
      type: Object
    }
  },

  vuex: {
    getters: {
      forms,
      config
    },
    actions: {
      addNotification,
      removeNotification
    }
  },

  events: {
    'fdata::input' (input) {
      this.$set('formInput', input[this.duplicate.field])
      this.confirm()
    }
  },

  methods: {
    confirm () {
      this.attempts++
      if (this.formData === this.formInput) {
        return this.removeNotification(this.duplicate.label)
      }
      if (this.config.inlineErrors) {
        this.$broadcast('parent::errors', {[this.duplicate.field]: [`${this.duplicate.label} must match ${this.original.label}`]})
      }
      this.addNotification({
        type: 'error',
        msg: [`${this.duplicate.label} must match ${this.original.label}`],
        id: this.duplicate.label,
        show: this.config.inlineErrors ? false : _.gt(this.attempts, 1)
      })
    }
  },

  watch: {
    formData: 'confirm'
  },

  computed: {
    original () {
      let fields = this.$parent.fdata === undefined ? _.find(this.forms, ['uid', this.uid]).fields
                                                    : this.$parent.fdata.content
      return _.find(fields, ['field', this.fdata.duplicateField])
    },

    formData () {
      let fields = _.find(this.forms, ['uid', this.uid]).data
      return fields[this.original.field]
    }
  },

  created () {
    // get original field and reset value
    this.$set('duplicate', _.assign({}, this.original, {
      label: `Confirm ${this.original.label}`,
      field: `DUPLICATE.${this.original.field}`,
      validation: [],
      value: ''
    }))
  },

  ready () {
    if (!this.paste) {
      let input = _.first(document.querySelectorAll(`input[name="${this.duplicate.field}"]`))
      input.onpaste = e => e.preventDefault()
    }
  }
}
</script>



// WEBPACK FOOTER //
// duplicate.vue?5c09f62c